module.exports = __webpack_public_path__ + "static/media/PIBKG_red.0a9fe69d.png";